import { render, staticRenderFns } from "./code-block.vue?vue&type=template&id=5cee4248&"
import script from "./code-block.vue?vue&type=script&lang=js&"
export * from "./code-block.vue?vue&type=script&lang=js&"
import style0 from "./code-block.vue?vue&type=style&index=0&id=5cee4248&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports